import { Component, OnInit } from '@angular/core';

import { AuthService } from './core/auth/auth.service';
@Component({
  selector: 'dx-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(public authService: AuthService) {}

  // ngOnInit() {
  //   this.loadCriticalLogo();
  //   debugger
  //   if (this.authService.isExpired) {
  //         console.log('Token expired, redirecting to login...');
  //         this.authService.login();
  //       } else {
  //         console.log('Token is valid, no need to login.');
  //       }
  // }
  ngOnInit(): void {
    this.loadCriticalLogo();
      if (!this.authService.error) {
        this.authService.login();
      }
  }

  private loadCriticalLogo() {
    document.getElementById('critical-logo').setAttribute('src', this.authService.appConfig.logo);
  }
}
